export default __webpack_public_path__ + "static/media/hover-imatge-ajudant@2x.d60dd42d.jpg";